import type { FaireProductEntity } from "../../entity_types/product";

export const p_9m5w3k7mje: FaireProductEntity = {
  token: "p_9m5w3k7mje",
  type: "product",
  name: "ScandiKitchen: The Essence of Hygge by Bronte Aurell",
  brandToken: "b_7a909d43",
  brandName: "Simon & Schuster",
  imageUrl:
    "https://cdn.faire.com/fastly/73362b1f816aae51ba328cbd65789c9690e4324103b4fc55edbe8d998430dbf4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/823f085c31efe7644497080f21aa6cbd52eb0bdf034ef92f89121956ffaae9ef.jpeg",
    "https://cdn.faire.com/fastly/9c6ccd2030aba4403cdb83c4451baeb2956ebe9ec8abb2246f7e5905fa8cdb4d.jpeg",
    "https://cdn.faire.com/fastly/42aa33f4ab1658fa69ac3d004c242ac17b019ec6a15fa40b4d4d0422c8a950ed.jpeg",
    "https://cdn.faire.com/fastly/4c30077ab65b2a3ea8bc2e31581f03e5c6519e6cbe8f803c4eaa50dbc11251ff.jpeg",
  ],
  priceDollars: 6.5,
  description:
    "[Ryland Peters & Small]\r\n\r\nDiscover the essence of hygge as revealed by Brontë Aurell, Danish owner of London’s ScandiKitchen in this honest and thoughtful guide, featuring some of her favourite recipes.\r\n\r\nHygge is in the zeitgeist, but what is it, how do we bring hygge into our lives and why are we so captivated with this Danish word? According to Brontë, it is really not complicated and doesn’t involve spending vast amounts of money on candles or blankets… in its purest form it is simply about appreciating life. Explained in 12 entertaining chapters interspersed with recipes, you will learn first about the origins of the word hygge and then how to embrace it. Essays include: Hygge and Happiness; Hygge and Baking; Hygge and Time; Hygge and Stress; Hygge and Soul; Hygge and Nature; and Hygge and Your Home. Hygge is a completely psychological and emotional state of being. Whether it’s going for a walk or sharing a cake with friends, when you carve a pocket of time in your day to apprec",
  tags: [],
  msrpDollars: 12.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:54.409Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
